import PropTypes from 'prop-types';
import { Slider } from '@web-stories-wp/design-system';
import { MULTIPLE_DISPLAY_VALUE, MULTIPLE_VALUE } from '../../../../constants';
import { StyledNumericInput } from './elements';
import {
  CompactFieldRow,
  NumericRow,
  SliderContainer,
  editableFieldStyle,
} from './textEffectStyles';

export default function TextEffectNumericField({
  field: { label, suffix, min = 0, max, unit },
  value,
  onChange,
  compact = false,
  withSlider = true,
}) {
  const change = (next) => {
    if (next !== '' && next !== MULTIPLE_VALUE && Number.isFinite(Number(next)))
      onChange(Math.min(max, Math.max(min, Number(next))));
  };
  const input = (
    <StyledNumericInput
      aria-label={label}
      unit={unit}
      min={min}
      max={max}
      isFloat
      value={value}
      isIndeterminate={value === MULTIPLE_VALUE}
      placeholder={value === MULTIPLE_VALUE ? MULTIPLE_DISPLAY_VALUE : null}
      containerStyleOverride={editableFieldStyle}
      onChange={(_event, next) => change(next)}
      onBlur={(_event, next) => change(next)}
    />
  );
  if (compact) return input;
  if (!withSlider)
    return (
      <CompactFieldRow>
        <span>{suffix}</span>
        {input}
      </CompactFieldRow>
    );
  return (
    <NumericRow>
      <span>{suffix}</span>
      <SliderContainer>
        <Slider
          aria-label={`${label} slider`}
          aria-valuenow={Number.isFinite(value) ? value : min}
          aria-valuetext={
            value === MULTIPLE_VALUE ? MULTIPLE_DISPLAY_VALUE : undefined
          }
          value={Number.isFinite(value) ? value : min}
          min={min}
          max={max}
          majorStep={1}
          minorStep={unit === 'px' ? 0.1 : 1}
          thumbSize={16}
          suffix={unit}
          handleChange={change}
        />
      </SliderContainer>
      {input}
    </NumericRow>
  );
}

TextEffectNumericField.propTypes = {
  field: PropTypes.shape({
    label: PropTypes.string.isRequired,
    suffix: PropTypes.string.isRequired,
    min: PropTypes.number,
    max: PropTypes.number.isRequired,
    unit: PropTypes.string.isRequired,
  }).isRequired,
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  onChange: PropTypes.func.isRequired,
  compact: PropTypes.bool,
  withSlider: PropTypes.bool,
};
